import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

/**
 * Alcuni flussi (es. recupero password) possono creare sessione senza lasciare
 * parametri utili nell'URL. In quel caso, l'evento PASSWORD_RECOVERY è la fonte
 * più affidabile per portare l'utente su /auth e mostrare la form di reset.
 */
const AuthEventRedirect = () => {
  const { lastAuthEvent } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (lastAuthEvent !== "PASSWORD_RECOVERY") return;
    if (location.pathname === "/auth") return;

    navigate({ pathname: "/auth", search: location.search, hash: location.hash }, { replace: true });
  }, [lastAuthEvent, location.pathname, location.search, location.hash, navigate]);

  return null;
};

export default AuthEventRedirect;
